import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const cubicationCostService = {
    fetchAll: async (params = {}) => {
      const response = await axiosInstance.get('/cubication-cost/paginate', {
        params,
      })
      return response.data
    },
    getById: async (id) => {
      const response = await axiosInstance.get('/cubication-cost/' + id)
      return response.data
    },
    store: async (data) => {
      const response = await axiosInstance.post('/cubication-cost', data)
      return response.data
    },
    update: async (data) => {
      const response = await axiosInstance.put(`/cubication-cost/${data.id}`, data)
      return response.data
    },
    delete: async (id) => {
      const response = await axiosInstance.delete(`/cubication-cost/${id}`)
      return response.data
    },
}